<template>
  <!-- Removed redundant div#app wrapper -->
  <v-app id="inspire" style="background-color: #f5f5f5 !important">
    <v-navigation-drawer
      v-model="drawer"
      app
      width="300px"
      color="#1E1E1E"
      dark
    >
      <v-list class="pa-0">
        <div
          style="
            background: radial-gradient(circle, #333333 0%, #000000 100%);
            border-bottom: 2px solid #d4af37;
            box-shadow: 0 4px 10px rgba(0, 0, 0, 0.5);
            padding: 20px 0;
          "
        >
          <a-row type="flex" justify="center" align="middle">
            <a-col :span="24" class="centerdiv">
              <v-img
                src="../assets/LogoSuedam.png"
                max-width="180"
                max-height="180"
                class="mx-auto rounded-xl"
                contain
                style="filter: drop-shadow(0 0 5px rgba(212, 175, 55, 0.3))"
              ></v-img>
            </a-col>
          </a-row>
        </div>
      </v-list>

      <a-menu
        mode="vertical"
        theme="dark"
        style="background-color: #1e1e1e; border-right: none"
      >
        <a-menu-item
          v-for="item in Navigator"
          :key="item.key"
          @click="ChangePage(item)"
          class="menu-item-custom"
        >
          <a-icon :type="item.icon" style="color: #d4af37; font-size: 18px" />
          <span class="pl-3" style="color: #e0e0e0; font-size: 16px">{{
            item.text
          }}</span>
        </a-menu-item>
      </a-menu>
    </v-navigation-drawer>

    <v-app-bar app color="#111111" dark elevation="4">
      <v-app-bar-nav-icon
        @click.stop="drawer = !drawer"
        style="color: #d4af37"
      ></v-app-bar-nav-icon>
      <h3 style="color: #d4af37; font-weight: bold; letter-spacing: 1px">
        {{ Header }}
      </h3>
      <v-spacer></v-spacer>
      <v-btn color="#D4AF37" text @click="Logout"
        >ออกจากระบบ<a-icon type="import" class="ml-2"
      /></v-btn>
    </v-app-bar>
    <v-main class="ma-4">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>
<script>
import { Decode } from "@/services";
export default {
  data() {
    return {
      // Powerball US
      // Powerball Aus
      // MegaMillions US
      // EuroJackpot EU
      // Mini Loto JP
      drawer: true,
      Header: "",
      // picture: "",
      username: "",
      NavigatorAdmin: [
        // {
        //   key: "dashboard",
        //   text: "Dashboard",
        //   path: "/Dashboard",
        //   name: "Dashboard",
        //   icon: "user",
        // },
        {
          key: "managelotto",
          text: "จัดการลอตเตอรี่",
          path: "/managelotto",
          name: "managelotto",
          icon: "user",
        },
        // {
        //   key: "dashboarddealer",
        //   text: "Dashboardตัวแทน",
        //   path: "/Dashboarddealer",
        //   name: "Dashboarddealer",
        //   icon: "user",
        // },
        {
          key: "menu1",
          text: "จัดการผู้ใช้งาน",
          path: "/ManageUser",
          name: "ManageUser",
          icon: "user",
        },
        {
          key: "menuAffiliate",
          text: "จัดการค่าแนะนำ",
          path: "/ManageAffiliate",
          name: "ManageAffiliate",
          icon: "dollar",
        },
        {
          key: "menuAffiliateReport",
          text: "รายงานค่าแนะนำ",
          path: "/AffiliateReport",
          name: "AffiliateReport",
          icon: "file-excel",
        },
        {
          key: "menu99",
          text: "จัดการแอดมิน",
          path: "/ManageAdmin",
          name: "ManageAdmin",
          icon: "user",
        },
        {
          key: "menu98",
          text: "จัดการแบนเนอร์",
          path: "/Managebanners",
          name: "ManageBanner",
          icon: "user",
        },
        {
          key: "ManageOrder",
          text: "รายการสั่งซื้อ ลอตเตอรี่ไทย",
          path: "/ManageOrder",
          name: "ManageOrder",
          icon: "shopping",
        },
        {
          key: "ManageOrderWinnings",
          text: "จัดการล็อตเตอรี่ที่ถูกรางวัล",
          path: "/ManageOrderWinnings",
          name: "ManageOrderWinnings",
          icon: "shopping",
        },

        // {
        //   key: "ManagePowerballOrder",
        //   text: "รายการสั่งซื้อ Powerball US",
        //   path: "/ManagePowerballOrder",
        //   name: "ManagePowerballOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManagePowerballblueOrder",
        //   text: "รายการสั่งซื้อ Powerball Aus",
        //   path: "/ManagePowerballblueOrder",
        //   name: "ManagePowerballblueOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageMegamillionsOrder",
        //   text: "รายการสั่งซื้อ MegaMillions US",
        //   path: "/ManageMegamillionsOrder",
        //   name: "ManageMegamillionsOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageEurojackpotOrder",
        //   text: "รายการสั่งซื้อ EuroJackpot EU",
        //   path: "/ManageEurojackpotOrder",
        //   name: "ManageEurojackpotOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLotteryjapanOrder",
        //   text: "รายการสั่งซื้อ Mini Loto JP",
        //   path: "/ManageLotteryjapanOrder",
        //   name: "ManageLotteryjapanOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLaoOrder",
        //   text: "รายการสั่งซื้อ หวยลาว",
        //   path: "/ManageLaoOrder",
        //   name: "ManageLaoOrder",
        //   icon: "shopping",
        // },
        {
          key: "ManageDealer",
          text: "จัดการตัวแทน",
          path: "/ManageDealer",
          name: "ManageDealer",
          icon: "user",
        },
        // {
        //   key: "CheckPWBPrizes",
        //   text: "ตรวจรางวัลPowerball US",
        //   path: "/CheckPWBPrizes",
        //   name: "CheckPWBPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckPWB_AUSPrizes",
        //   text: "ตรวจรางวัลPowerball Aus",
        //   path: "/CheckPWB_AUSPrizes",
        //   name: "CheckPWB_AUSPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckPWB_MegaPrizes",
        //   text: "ตรวจรางวัล MegaMillions US",
        //   path: "/CheckPWB_MegaPrizes",
        //   name: "CheckPWB_MegaPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckPWB_EuroPrizes",
        //   text: "ตรวจรางวัล EuroJackpot EU",
        //   path: "/CheckPWB_EuroPrizes",
        //   name: "CheckPWB_EuroPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckPWB_JapanPrizes",
        //   text: "ตรวจรางวัล Mini Loto JP",
        //   path: "/CheckPWB_JapanPrizes",
        //   name: "CheckPWB_JapanPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckLaoPrizes",
        //   text: "ตรวจรางวัลลอตเตอรี่ลาว",
        //   path: "/CheckLaoPrizes",
        //   name: "CheckLaoPrizes",
        //   icon: "dollar",
        // },
        {
          key: "configService",
          text: "จัดการระบบ",
          path: "/configService",
          name: "configService",
          icon: "unordered-list",
        },
      ],
      NavigatorAdminSub: [
        {
          key: "managelotto",
          text: "จัดการลอตเตอรี่",
          path: "/managelotto",
          name: "managelotto",
          icon: "user",
        },
        {
          key: "menu1",
          text: "จัดการผู้ใช้งาน",
          path: "/ManageUser",
          name: "ManageUser",
          icon: "user",
        },
        // {
        //   key: "menu99",
        //   text: "จัดการแอดมิน",
        //   path: "/ManageAdmin",
        //   name: "ManageAdmin",
        //   icon: "user",
        // },
        {
          key: "menu98",
          text: "จัดการแบนเนอร์",
          path: "/Managebanners",
          name: "ManageBanner",
          icon: "user",
        },
        {
          key: "ManageOrder",
          text: "รายการสั่งซื้อ ลอตเตอรี่ไทย",
          path: "/ManageOrder",
          name: "ManageOrder",
          icon: "shopping",
        },
        {
          key: "ManageOrderWinnings",
          text: "จัดการล็อตเตอรี่ที่ถูกรางวัล",
          path: "/ManageOrderWinnings",
          name: "ManageOrderWinnings",
          icon: "shopping",
        },
        {
          key: "ManageDealer",
          text: "จัดการตัวแทน",
          path: "/ManageDealer",
          name: "ManageDealer",
          icon: "user",
        },
        {
          key: "configService",
          text: "จัดการระบบ",
          path: "/configService",
          name: "configService",
          icon: "unordered-list",
        },
      ],
      NavigatorHelper: [
        {
          key: "ManageOrder",
          text: "รายการสั่งซื้อ ลอตเตอรี่ไทย",
          path: "/ManageOrder",
          name: "ManageOrder",
          icon: "shopping",
        },
      ],
      NavigatorDefault: [
        // {
        //   key: "dashboard",
        //   text: "Dashboard",
        //   path: "/Dashboard",
        //   name: "Dashboard",
        //   icon: "user",
        // },
        {
          key: "menu1",
          text: "จัดการผู้ใช้งาน",
          path: "/ManageUser",
          name: "ManageUser",
          icon: "user",
        },
        {
          key: "ManageOrder",
          text: "รายการสั่งซื้อ ลอตเตอรี่ไทย",
          path: "/ManageOrder",
          name: "ManageOrder",
          icon: "shopping",
        },

        {
          key: "ManageOrderWinnings",
          text: "จัดการล็อตเตอรี่ที่ถูกรางวัล",
          path: "/ManageOrderWinnings",
          name: "ManageOrderWinnings",
          icon: "shopping",
        },
        // {
        //   key: "ManagePowerballOrder",
        //   text: "รายการสั่งซื้อ Powerball US",
        //   path: "/ManagePowerballOrder",
        //   name: "ManagePowerballOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManagePowerballblueOrder",
        //   text: "รายการสั่งซื้อ Powerball Aus",
        //   path: "/ManagePowerballblueOrder",
        //   name: "ManagePowerballblueOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageMegamillionsOrder",
        //   text: "รายการสั่งซื้อ MegaMillions US",
        //   path: "/ManageMegamillionsOrder",
        //   name: "ManageMegamillionsOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageEurojackpotOrder",
        //   text: "รายการสั่งซื้อ EuroJackpot EU",
        //   path: "/ManageEurojackpotOrder",
        //   name: "ManageEurojackpotOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLotteryjapanOrder",
        //   text: "รายการสั่งซื้อ Mini Loto JP",
        //   path: "/ManageLotteryjapanOrder",
        //   name: "ManageLotteryjapanOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLaoOrder",
        //   text: "รายการสั่งซื้อ หวยลาว",
        //   path: "/ManageLaoOrder",
        //   name: "ManageLaoOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageDealer",
        //   text: "จัดการตัวแทน",
        //   path: "/ManageDealer",
        //   name: "ManageDealer",
        //   icon: "user",
        // },
      ],
      NavigatorAccounting: [
        {
          key: "menu1",
          text: "จัดการผู้ใช้งาน",
          path: "/ManageUser",
          name: "ManageUser",
          icon: "user",
        },
        {
          key: "ManageOrder",
          text: "รายการสั่งซื้อ ลอตเตอรี่ไทย",
          path: "/ManageOrder",
          name: "ManageOrder",
          icon: "shopping",
        },
        {
          key: "ManageOrderWinnings",
          text: "จัดการล็อตเตอรี่ที่ถูกรางวัล",
          path: "/ManageOrderWinnings",
          name: "ManageOrderWinnings",
          icon: "shopping",
        },
        {
          key: "ManageDealer",
          text: "จัดการตัวแทน",
          path: "/ManageDealer",
          name: "ManageDealer",
          icon: "user",
        },
        {
          key: "configService",
          text: "จัดการระบบ",
          path: "/configService",
          name: "configService",
          icon: "unordered-list",
        },
        // {
        //   key: "ManagePowerballOrder",
        //   text: "รายการสั่งซื้อ Powerball US",
        //   path: "/ManagePowerballOrder",
        //   name: "ManagePowerballOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManagePowerballblueOrder",
        //   text: "รายการสั่งซื้อ Powerball Aus",
        //   path: "/ManagePowerballblueOrder",
        //   name: "ManagePowerballblueOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageMegamillionsOrder",
        //   text: "รายการสั่งซื้อ MegaMillions US",
        //   path: "/ManageMegamillionsOrder",
        //   name: "ManageMegamillionsOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageEurojackpotOrder",
        //   text: "รายการสั่งซื้อ EuroJackpot EU",
        //   path: "/ManageEurojackpotOrder",
        //   name: "ManageEurojackpotOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLotteryjapanOrder",
        //   text: "รายการสั่งซื้อ Mini Loto JP",
        //   path: "/ManageLotteryjapanOrder",
        //   name: "ManageLotteryjapanOrder",
        //   icon: "shopping",
        // },
        // {
        //   key: "ManageLaoOrder",
        //   text: "รายการสั่งซื้อ หวยลาว",
        //   path: "/ManageLaoOrder",
        //   name: "ManageLaoOrder",
        //   icon: "shopping",
        // },

        // {
        //   key: "CheckPWBPrizes",
        //   text: "ตรวจรางวัลพาวเวอร์บอล",
        //   path: "/CheckPWBPrizes",
        //   name: "CheckPWBPrizes",
        //   icon: "dollar",
        // },
        // {
        //   key: "CheckLaoPrizes",
        //   text: "ตรวจรางวัลลอตเตอรี่ลาว",
        //   path: "/CheckLaoPrizes",
        //   name: "CheckLaoPrizes",
        //   icon: "dollar",
        // },
      ],
      Navigator: [],
    };
  },
  created() {
    // รายการสั่งซื้อ จัดการตัวแทน และจัดการผู้ใช้งาน
    // this.Navigator = this.NavigatorDefault;
    var checkuser = JSON.parse(
      Decode.decode(localStorage.getItem("DDLotAdmin"))
    );
    console.log("checkuser", checkuser.user);
    // this.username = checkuser.name;
    // console.log("username", this.username);
    if (
      checkuser.user.telNumber == "0990569595" ||
      checkuser.user.telNumber == "0969696671" ||
      checkuser.user.telNumber == "0823289295"
    ) {
      this.Navigator = this.NavigatorAdmin;
    }
    // else if (checkuser.user.telNumber == "0823289295") {
    // this.Navigator = this.NavigatorAdminSub;
    // }
    else if (checkuser.user.agentId == null) {
      this.Navigator = this.NavigatorAccounting;
    } else {
      this.Navigator = this.NavigatorDefault;
    }

    // เชค helper //
    if (checkuser.user.isHelper == 1) {
      if (checkuser.user.userType == "ADMIN") {
        if (
          checkuser.user.telNumber == "0823289295" ||
          checkuser.user.telNumber == "0990569595" ||
          checkuser.user.telNumber == "0969696671"
        ) {
          this.Navigator = this.NavigatorAdmin;
        }
        // else if (checkuser.user.telNumber == "0823289295") {
        //   this.Navigator = this.NavigatorAdminSub;
        // }
        else {
          this.Navigator = this.NavigatorDefault;
        }
      } else {
        this.Navigator = this.NavigatorHelper;
        this.$router.currentRoute.path == "/ManageOrder"
          ? ""
          : this.$router.push("/ManageOrder");
      }
    }
    // ออยล์ 098-154-6656
    // น๊อต 082-689-5453
    // โอ๋ 086-505-7173
    // เอิร์ธ 082-553-8685
    // Paanrada 080-945-4464
    // Paanrada 098-582-8555
    // Paanrada 094-636-9942
    // บอย 091-824-9553
    // จิ๊บ 0649855654
    // ไอซ์ 0927728421
    // แบงค์ 091-794-7959
    // อุ้ม 063-649-7464
    // ปุย 090-971-2035
    // ติ๋ม 090-965-6599
    // นา 081-866-8354
    // สุพิศ 088-901-7930
    // นวล 081-931-9256

    this.CheckHeader();
  },
  methods: {
    async ChangePage(val) {
      // // console.log('เข้า ChangePage', val)
      // // console.log(val, this.$router.currentRoute)
      if (val.name !== this.$router.currentRoute.name) {
        this.$router.push({ path: val.path }).catch(() => {});
      }
    },
    CheckHeader(val) {
      this.Header = val;
    },
    Logout() {
      localStorage.removeItem("DDLotAdmin");
      window.location.reload();
    },
  },
};
</script>
<style scoped>
.centerdiv {
  display: flex !important;
  justify-content: center !important;
  align-items: center !important;
}
.div_overflow {
  overflow: auto;
  width: 100%;
  height: 89vh;
}
</style>
<style>
.v-application ul,
.v-application ol {
  padding: 0px 0px !important;
}

/* Menu Item Hover Effect */
.menu-item-custom:hover {
  background-color: #333333 !important;
  transition: background-color 0.3s;
}

.menu-item-custom:hover span {
  color: #ffffff !important;
  font-weight: 500;
}

.menu-item-custom.ant-menu-item-selected {
  background-color: #2a2a2a !important;
  border-right: 3px solid #d4af37;
}

.menu-item-custom.ant-menu-item-selected span {
  color: #d4af37 !important;
  font-weight: bold;
}
</style>
